import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Utente } from "../interfaces/user";
import { Attori } from "../shared/enum/attori.enum";

@Injectable({ providedIn: 'root' })
export class AppService {

  constructor(
    private http: HttpClient
  ) { }

  private _user: Utente = {};
  private _timestamp: string = '';

  get attore(): Attori | number{
    const u = this._user;
    if (u.isUtenteCFO) return Attori.CFO;
    if (u.isUtenteDG) return Attori.DirettoreGenerale;
    if (u.isUtenteResponsabilePrimoLivello) return Attori.ResponsabilePrimoLivello;
    if (u.isUtenteControllerCentrale) return Attori.ControllerCentrale;
    if (u.isUtenteControllerBU) return Attori.ControllerBU;
    return 0;
  }

  get user() {
    return this._user;
  }
  set user(user: Utente) {
    this._user = user;
  }

  get timestamp() {
    return this._timestamp;
  }
  set timestamp(timestamp: string) {
    this._timestamp = timestamp;
  }

  get(): Observable<any> {
    return this.http.get('api/utente');
  }
}
